import React from "react";

// Badge "vérifié" façon bouclier — icône noire, coché blanc — repris partout dans l'app
// (auparavant un simple "✓" texte à certains endroits, incohérent avec ProfileVisitor.tsx).
export default function VerifiedBadge({ size = 15 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
      <path d="M12 2L4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5L12 2z" fill="#0a0a0a" />
      <polyline points="9 12 11 14 15 10" stroke="white" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
